import {
  HIDE_ICON_FOR_SHARED_NAVIGATION_BAR,
  DISPLAY_ICON_FOR_SHARED_NAVIGATION_BAR,
  SET_NAVIGATION_ACTIVE,
  HIDE_NAVIGATION,
  DISPLAY_NAVIGATION
} from './constants';

const initialState = {
  actions: []
};

const reducer = (state = initialState, {type, payload}) => {
  switch (type) {
    case HIDE_ICON_FOR_SHARED_NAVIGATION_BAR:
    case DISPLAY_ICON_FOR_SHARED_NAVIGATION_BAR:
    case SET_NAVIGATION_ACTIVE:
      return {
        ...state,
        actions: state.actions.map(x => actionReducer(x, {type, payload}))
      };
    case HIDE_NAVIGATION:
      return {
        ...state,
        actions: []
      };
    case DISPLAY_NAVIGATION:
      return {
        ...state,
        actions: payload
      };
    default:
      return state;
  }
};

const actionInitialState = {
  active: false,
  navOrigin: false,
  to: '',
  label: '',
  iconClassName: '',
  iconColorClassName: ''
};

const actionReducer = (state = actionInitialState, {type, payload}) => {
  switch (type) {
    case HIDE_ICON_FOR_SHARED_NAVIGATION_BAR:
      return state.key === payload
        ? {
          ...state,
          iconClassName: actionInitialState.iconClassName,
          iconColorClassName: actionInitialState.iconColorClassName
        }
        : state;
    case DISPLAY_ICON_FOR_SHARED_NAVIGATION_BAR:
      return state.key === payload.key
        ? {
          ...state,
          iconClassName: payload.iconClassName || actionInitialState.iconClassName,
          iconColorClassName: payload.iconColorClassName || actionInitialState.iconColorClassName
        }
        : state;
    case SET_NAVIGATION_ACTIVE:
      return {
        ...state,
        active: state.key === payload
      };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/features/shared/navigationBar/reducer.js